<template>
  <div>template distributed hybrid</div>
  <pre>{{ $route.query }}</pre>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useAppStore } from "@/stores/app.store";
export default defineComponent({
  name: "template-distributed-hybrid",
  data() {
    return {
      appStore: useAppStore(),
    };
  },
  created() {
    this.appStore.setPageLoading(false);
  },
});
</script>
